import React from 'react';

/**
 * Tractie-spec Select chevron icon.
 *
 * Exacte SVG-path uit Tractie's shadow-DOM `input-group__input::after`
 * mask-image (verified 2026-05-22 via getComputedStyle). Wijkt af van
 * MUI's `KeyboardArrowDown` en BUI's react-aria chevron — voor exacte
 * pixel-pariteit gebruikt MUI Select deze component als IconComponent.
 *
 * Path: rounded v-stroke, 24×24 viewBox, fill currentColor.
 */
export const TractieChevronDownIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(function TractieChevronDownIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0001 15.7302L5.65007 9.33021C5.46007 9.13021 5.46007 8.82021 5.65007 8.62021C5.84007 8.42021 6.16007 8.42021 6.36007 8.62021L12.0101 14.3002L17.6601 8.62021C17.8501 8.42021 18.1701 8.42021 18.3701 8.62021C18.5701 8.81021 18.5701 9.13021 18.3701 9.33021L12.0201 15.7302H12.0001Z"
        fill="currentColor"
      />
    </svg>
  );
});
